import { FireActionItemService } from './../../../../services/fire-action-items/fire-action-item.service';
import { ActionItems } from './../../../../models/actionItems';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import * as firebase from 'firebase/app';
import { DataSnapshot } from '@angular/fire/database/interfaces';
import { CommonModule } from '@angular/common';
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { assessmentApiEndpoint } from 'src/app/consts/conts.global';
import { HttpClient } from '@angular/common/http';
import { filter, first, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Business } from 'src/app/models/business';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { AngularFirestore } from '@angular/fire/firestore';
import { DateAdapter } from '@angular/material/core';
import { AuthService } from 'src/app/shared/service/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '../../../confirmation-box/confirmation-box.component';

interface ImplementationStatus {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-action-item-list',
  templateUrl: './action-item-list.component.html',
  styleUrls: ['./action-item-list.component.scss'],
})

export class ActionItemListComponent implements OnInit {


  statResp: ImplementationStatus[] = [
    {value: 'no', viewValue: 'No'},
    {value: 'yes', viewValue: 'Yes'},
  ];

  AIbusiRegType;
  AIbusiRegType2;
  
 
  
  constructor(
    public fireAssessment: FireAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private guard: AuthGuard,
    private http: HttpClient,
    private _formBuilder: FormBuilder,
    public fireActionItem: FireActionItemService,
    private firestoredb: AngularFirestore,
    public authService:AuthService,
    private dialog: MatDialog
  ) {
   }

  



  //declare form variable here
  p = 1;  // Setup up pagination variable
  Assessment: Business[]; // Save assessment data in Assessment's array.
  hideWhenNoActionItem = false; // Hide assessment data table when no assessment.
  noData = false;            // Showing No Assessment Message, when no assessment in database.
  //itemKeys = [];
  data!: any;
  assessmentKey!: any;
 // readAssessmenListSub: Subscription;
  //@ViewChild('new-assessment') assessmentButton: HTMLButtonElement;

 public actionItemList: ActionItems [] = [];
      actionItem: any;
      assessmentPayload: any;
      actionItemFormGroup: FormGroup;
      actionItemArray: FormArray;
      actionItemID: any;
      itemKeys = [];
      dataArray = [];
      dataSource;


applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

 public aItemdata: any;
  public  dataActionItem!: any;
  actionItemData: any;

  ActIPriorityLevel = [
    { value: 1, name: 'Low' },
    { value: 2,name: 'Medium' },
    { value: 3,name: 'High' },
  ]

  ActIDifficultyLevel = [
    { value: 1, name: 'Easy' },
    { value: 2,name: 'Medium' },
    { value: 3,name: 'Hard' },
  ]
  

  ngOnInit(): void {
    this.loadUserActionItems();
    this.newActionItem();
 
  }

actionItemListCheck : any;
 



readSustainibleActionItem(id:string) {
  //define all variables of a single assessment
this.aItemdata = this.fireActionItem.sustainibleActionItemRef.doc(id);
this.aItemdata.get().toPromise().then((payload: any) => {
this.dataActionItem = payload?.data(); 

});
}

/*
  ngAfterOnInit() {
   // this.actionItemArray = this.actionItemFormGroup.get('actionItemArray') as FormArray;
  }

  actionItemForm() {
    this.actionItemFormGroup  = this._formBuilder.group({
      actionItemArray: this._formBuilder.array([]),
      
    })
  }

  async getActionItemDoc(){
  
  const userAcions = await this.firestoredb.collection('user-actionItem', ref => ref.where('userID', '==', this.guard.uid)).get().toPromise();
  userAcions.forEach((doc) => {
    this.actionItemID = doc.id;
    this.actionItemData = doc.data(); 
   
  })
}

//Add Team Members
getActionItem() : FormArray {
  return this.actionItemFormGroup.get("actionItemArray") as FormArray
}

newActionItem(): FormGroup {
  return this._formBuilder.group({
    actionItemName: ['' , Validators.required],
    actionItemNotes: ['' , Validators.required],
    actionItemDueDate: ['' , Validators.required],
    isEditable: [true],
    deleted: [false],
  })
}

addActionItem() {
  this.getActionItem().push(this.newActionItem());
}

removeActionItem(i:number, group: FormGroup) {
 group.get('deleted').setValue(true);//write code to update the 'deleted' field to true then on refresh, don't show action items that have been deleted in the list. Or make a seprate list that only shows deleted (do the same for completed)
  this.getActionItem().removeAt(i);
 // this.fireActionItem.deleteSustainibleActionItem(this.actionItemID, i);
/* this.firestoredb.collection('user-actionItem').doc(this.actionItemID).update({
  actionItemArray:  firebase.firestore.FieldValue.arrayRemove()
})
}


update(group: FormGroup){//if doc with action item name exists then update, if not, then create new
  
  group.get('isEditable').setValue(false);

  this.fireActionItem.updateSustainibleActionItem(this.actionItemID, this.actionItemFormGroup.value);
  this.readSustainibleActionItem(this.actionItemID);
}
touchedRows: any;
*/

actionItemCategory = [
  'Strategy',
  'Hiring & HR',
  'Business Opeartions',
   'Legal',
  'Finance',
  'Marketing',
  'Other',
 ]

 actionItemTimeFrame = [
  'Under 5 mins',
  '10-15 mins',
  '15-30 mins',
  '30 mins-1 hour',
  '1hour+',
 ]



newActionItem() {
  this.actionItemFormGroup = this._formBuilder.group({
    actionItemName: ['', Validators.required],
    actionItemDueDate: null,
    actionItemResource: null,
    actionItemCategory: [null , Validators.required],
    actionItemNotes: null,
    actionItemPriority: null,
    actionItemDifficulty: null,
    actionItemTimeFrame: null,
    actionItemStatus: null,
    actionItemOrigin: "User",
    actionItemDateCreated: null,
    actionItemIsEditable: true,
  })
}


addActionItemtoFirestore(){
  
  this.fireActionItem.createSustainibleActionItem(this.actionItemFormGroup.value);
  this.actionItemFormGroup.reset();
}

//delete 
remove(id:string): void {
  const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
    disableClose: true,
    data: {
      title: 'Delete',
      content: `You are about to delete an action plan item. You cannot undo this. Are you sure you want to continue?`,
      //content: `This action can not be undone and you <strong>will be unlinked</strong> to any assessments associated with this code. <br/>Your clients' assessments <strong>will be removed</strong> from your assessments list.`,
      action: 'Delete'
    }
  });
  dialogRef.afterClosed()
  .pipe(filter(response => response === 'Delete'))
  .subscribe(() => {
    this.fireActionItem.deleteSustainibleActionItemDoc(id)
  });
}


deleteSustainibleActionItem (id:string) {
  
  this.fireActionItem.deleteSustainibleActionItemDoc(id);
}



updateActionItem(){
  this.fireActionItem.updateSustainibleActionItem(this.actionItemFormGroup.value.key, this.actionItemFormGroup.value);
}

editActionItem(group: FormGroup) {
  group.get('isEditable').setValue(true);
}


loadUserActionItems(){
  
  //const actionItemList = this.fireActionItem.readSustainibleActionItemList();
 /* const actionItemList = this.firestoredb.collection('users').doc(`${this.guard.uid}`).collection('actionItems').get().toPromise();
    actionItemList.then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
      this.actionItemID = doc.id;
      this.actionItemData = doc.data(); 
   
    })
  })*/
  const actionItemList2 =  this.fireActionItem.readSustainibleActionItemList();
  this.firestoredb.collection('users').doc(`${this.guard.uid}`).collection('actionItems').get()
      // .pipe(first(), filter(value => !!value?.length && this.authService.isAdmin))
      .pipe(map((payload: any) => {
        const allActionItems = payload.docs.map((doc: any) => { 
          return {key: doc.id, ...doc.data() }});
          const userBusinessInfo = allActionItems?.length;
          return userBusinessInfo;
        }), filter(value => !!value?.length))
      .subscribe(usersInfo => {
        const newData = [...this.dataArray, ...usersInfo];
        this.dataArray = [...newData.reduce((map, obj) => map.set(obj?.key, obj), new Map()).values()];
        this.dataSource = new MatTableDataSource(this.dataArray)
      });

      actionItemList2.snapshotChanges().pipe(
      map(actions =>
        actions.map(a => ({ key: a.payload.doc.id, ...a.payload.doc.data() }))
      )
    ).subscribe(dataArray => {
      this.itemKeys = dataArray.map(item => item.key);
      this.dataArray = dataArray;
      return this.itemKeys;
    });
}


  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' }
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }

/*onSubmit() {
  
  const actionItemID = this.fireActionItem.createActionItem({...this.actionItemFormGroup.value})
.then((id)=>{
 this.actionItemID = id;

 this.getActionItemID(id);
}).catch((e)=>{
  console.log("error", e);
}); // Submit data using CRUD API//take out value? 
//this.getBPlanID(id);
  const control = this.actionItemFormGroup.get("actionItemArray") as FormArray
  this.touchedRows = control.controls.filter(row => row.touched).map(row => row.value);

}*/




   
 
   
}
